import { useQuery } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

export function usePublicProposal(token: string) {
  return useQuery({
    queryKey: ['publicProposal', token],
    queryFn: () => publicProposalApi.findOne(token),
    enabled: !!token,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
